import { ITelemetryConfig } from "./TelemetryService.types";

const instrumentationKey = process.env.REACT_APP_IKEY;
const envName = process.env.REACT_APP_ENVIRONMENT;

export default {
    AIKey: instrumentationKey,
    EnvironmentName: envName
} as ITelemetryConfig;
